export function useHeaderNavbarSubmenus() {
  const storyblokStore = useStoryblokStore()

  const submenus = computed(() => {
    return storyblokStore.state.submenus
  })

  return {
    submenus,
  }
}
